export default __webpack_public_path__ + "static/media/ru.js.fc8c5310.map";